export enum StrengthProficiency {
    STRONGLY_DISAGREE = 'STRONGLY_DISAGREE',
    DISAGREE = 'DISAGREE',
    NEUTRAL = 'NEUTRAL',
    AGREE = 'AGREE',
    STRONGLY_AGREE = 'STRONGLY_AGREE',
}
